import BaseController from "./BaseController";
import http from "../../Store/baseHttp";
import ResponseObject from "../../DataObjects/ResponseObject";
import { redirect } from "react-router-dom";
import UserObject from "../../DataObjects/UserObject";
// import cookieSignature from "cookie-signature";

export async function InvoiceLoader({ request, params }) {
  const url = new URL(request.url);
  try {
    let response = await http.get(
      "/invoice/list" + url.search + "&sort_type=DESC"
    );
    response = ResponseObject.from(response);
    return response;
  } catch (e) {
    return ResponseObject.from(e?.response);
  }
}
function getInvoiceLink(token, redirect) {
  const enviroment = process.env.REACT_APP_VERCEL_ENV !== "production";
  const redirectTo = redirect || "/";
  const redirectLink = !enviroment
    ? `https://beta.fedacash.com/api/auth/bridge?token=${token}&redirectTo=${redirectTo}`
    : `http://localhost:3000/api/auth/bridge?token=${token}&redirectTo=${redirectTo}`;
  return redirectLink;
}
class InvoiceService extends BaseController {
  async index({ request, params }) {
    const url = new URL(request.url);
    const { token } = UserObject.getUser();
    const COOKIE_SECRET = process.env.REACT_APP_COOKIE_SECRET_KEY;
    // const signedCookie = cookieSignature.sign(token, COOKIE_SECRET)
    // console.log("signed cookie",signedCookie)
    const redirectLink = getInvoiceLink(token, "/dashboard/invoice");
    try {
      let response = await http.get("/invoice/list" + url.search);
      // console.log("invoice resposne", response)
      response = ResponseObject.from(response);
      window.location.href= redirectLink
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  static async template({ request, params }) {
    const { token } = UserObject.getUser();
    const COOKIE_SECRET = process.env.REACT_APP_COOKIE_SECRET_KEY;
    const redirectLink = getInvoiceLink(token, "/dashboard/invoice/create?type=new");
    try {
      let response = await http.get("/invoice/template");
      response = ResponseObject.from(response);
      window.location.href= redirectLink
      // return redirect(redirectLink);
      // console.log("redirectLink",redirectLink)
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  static async email({ request, params }) {
    let formData = Object.fromEntries(await request.formData());
    formData.company_emails = formData.company_email
      .split(",")
      .map((v) => v.trim());
    try {
      let response = await http.put("/invoice/send-as-mail", formData);
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  static async downlod(id) {
    try {
      let response = await http.get("/invoice/download/" + id);
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  async post({ request }) {
    let formData = Object.fromEntries(await request.formData());
    formData.invoice_number = formData.invoice_number.replace("₦", "");
    formData.company_emails = formData.company_email
      ?.split(",")
      .map((v) => v.trim());
    formData.items = JSON.parse(formData.items).map((v) => {
      if (v.unit_price) {
        v.unit_price = v.unit_price.replace("₦", "").replaceAll(",", "");
      }
      return v;
    });
    console.log("formdata", formData);
    try {
      let response = await http.post("/invoice/create", formData, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      });
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }
}

export default InvoiceService;
